/*
|--------------------------------------------------------------------------
|
| 对应 package.json/appGroupName
|
|--------------------------------------------------------------------------
*/

export const LIB_NAME = 'hel-tpl-remote-vue-comps';
